import React, { FC } from 'react';
import { isImpersonating } from '@aarhus-university/au-lib-react-components/src/lib/portals';
import ProfileLoginComponent from './ProfileLoginComponent';
import ProfileAvatarComponent from './ProfileAvatarComponent';
import NotificationsComponent from './NotificationsComponent';
import { useImpersonationContext } from '../../lib/context';

const UtilityComponent: FC = () => {
  const { isStudent, isImpersonator } = useImpersonationContext();
  const canImpersonateButHaveNotActivatedItYet = isImpersonator && !isStudent && !isImpersonating();
  const noAccess = !isStudent && !isImpersonator;
  return (
    <ProfileLoginComponent>
      <>
        {
          (!canImpersonateButHaveNotActivatedItYet && !noAccess) && (
            <NotificationsComponent />
          )
        }
        <ProfileAvatarComponent />
      </>
    </ProfileLoginComponent>
  );
};

UtilityComponent.displayName = 'UtilityComponent';
export default UtilityComponent;
